const SEPARATOR = ':';

/**
 * One value for a model + elevation pair, so a home plan is picked in one step (as on Option Packages).
 * It is the API's own `modelElevations` format, so the value goes to the API unchanged. null until both are known.
 */
export function toDsmModelElevationKey(modelId: string | null, elevationId: string | null): string | null {
  return modelId && elevationId ? `${modelId}${SEPARATOR}${elevationId}` : null;
}

export function fromDsmModelElevationKey(key: string | null | undefined): {
  modelId: string | null;
  elevationId: string | null;
} {
  const [modelId, elevationId] = key?.split(SEPARATOR) ?? [];
  return modelId && elevationId ? { modelId, elevationId } : { modelId: null, elevationId: null };
}
